// extracted by mini-css-extract-plugin
export default {"queue-container":"Queue_queue-container__-t9wE","add-track-button":"Queue_add-track-button__3H7jI","plus":"Queue_plus__H-yW8","disc":"Queue_disc__csai4","queue":"Queue_queue__qaqUf"};